<template>
	<v-menu offset-y>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				depressed
				color="warning"
				x-small
				icon
				@click="btnClick"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon small class="mb-1">mdi-eye-outline</v-icon>
			</v-btn>
		</template>
		<v-list dense class="py-0">
			<v-list-item dense class="mb-1 px-2" style="min-height: 25px; background: #959595;">
				<div class="d-flex justify-space-between align-center" style="width: 100%;">
					<p class="caption mb-0 font-weight-bold white--text">Línea de Proyecto</p>
					<p class="caption mb-0 font-weight-bold white--text">#{{ projectLineAssociations?.project_line_id }}</p>
				</div>
			</v-list-item>
			<v-list-item-group color="#524D4D">
				<v-list-item
					v-for="(association, index) in mappedProjectLineAssociations"
					:key="'ass-'+index"
					dense
					@click="handleGoTo(association)"
					style="min-width: 200px"
					class="px-2"
				>
					<v-list-item-title dense>
						<div class="d-flex justify-space-between align-center item-background-hover">
							<div class="d-flex justify-space-between caption" style="width: 100%">
								<div>{{ association.type_name }}</div>
								<v-icon small>mdi-chevron-right</v-icon>
							</div>
						</div>
					</v-list-item-title>
				</v-list-item>
			</v-list-item-group>
		</v-list>
	</v-menu>
</template>

<script>
export default {
	name: 'ProjectLineAssociationMenu',
	props: {
		projectLineAssociations: {
			type: Object,
			default: null
		},
		btnClick: {
			type: Function
		}
	},
	computed: {
		mappedProjectLineAssociations(){
			if(this.projectLineAssociations?.associations){
				return this.projectLineAssociations.associations.map((association) => {
					return {...association, ...{type_name: this.getAssociationType(association.morphable_type)}}
				})
			}
			return []
		},
	},
	methods:{
		getAssociationType(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'CRM / Visita Técnica'
				case "App\\Models\\PreProject":
					return 'PreProyecto'
				case "App\\Models\\Project":
					return 'Proyecto'
				default:
					return 'Otro'
			}
		},
		handleGoTo(association){
			if(association.morphable_type == 'App\\Models\\PreProject'){
				this.$store.commit('preprojects/setPreProjectModalId', association.morphable_id)
			}
			else if(association.morphable_type == 'App\\Models\\BotConversation'){
				this.$store.commit('crm/setCrmModalId', association.morphable_id)
			}
		},
	}
}
</script>

<style>

</style>